<ion-app>
  <ion-router-outlet></ion-router-outlet>

  @if ( load.certs() || load.langPref() || load.servs() || load.user() || load.workPref() || load.adminApp() ||
  load.attProf() ) {
  <div class="site-load">
    <CDMS-common-load-indicator-control
      class="site-load-indicator"
      [show]="
          load.certs() ||
          load.langPref() ||
          load.servs() ||
          load.user() ||
          load.workPref() ||
          load.adminApp() ||
          load.attProf()
        ">
    </CDMS-common-load-indicator-control>
  </div>
  }
</ion-app>
